export default __webpack_public_path__ + "static/media/tabletop-mockup.236156cb.png";